import { render, staticRenderFns } from "./SubLegCampsites.vue?vue&type=template&id=4ea45092&"
import script from "./SubLegCampsites.vue?vue&type=script&lang=js&"
export * from "./SubLegCampsites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports